<template>
    <div
        v-if="exist"
        v-show="visible"
        class="md-demographic fashion"
        :style="{ marginBottom }"
    >
        <div class="md-demographic-content">
            <module-box
                :fullColumn="fullColumn"
                :topSpacing="topSpacing"
                :btmSpacing="btmSpacing"
                :mobileTopSpacing="mobileTopSpacing"
                :mobileBtmSpacing="mobileBtmSpacing"
                noPadding
                noMargin
            >
                <div class="title-container">
                    <div
                        class="mg-title"
                        v-html="formatFontSize(title, '--mg-title-size')"
                    ></div>
                    <a
                        :href="listingDetail.introUrlByListing"
                        v-if="listingDetail.introUrlByListing"
                        rel="noopener noreferrer"
                        class="refine-intro"
                    ><i class="iconfont icon-community"></i
                    >{{ $t('md-demographic.refineSearch') }}</a
                    >
                </div>
                <ul class="demographic-content">
                    <li
                        v-for="(item, index) in demographics"
                        class="item"
                        :key="'item' + index"
                    >
                        <div class="info">
                            <p class="number" data-format="${item.type}">
                                {{ item.value }}
                            </p>
                            <p class="text">{{ item.label }}</p>
                        </div>
                    </li>
                </ul>
                <div
                    class="source"
                    v-html="$t('md-demographic.dataProvidedBy')"
                ></div>
            </module-box>
        </div>
    </div>
</template>

<script>
import Common from '../index.js';
export default {
    mixins: [Common],
    data: function() {
        return {};
    }
};
</script>
<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';
.md-demographic.fashion {
    .source {
        padding-top: 10px;
        padding-bottom: 0px;
        color: #8b93a7;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        a {
            text-decoration: underline;
            color: var(--color-theme, #03c9ff);
        }
    }
    .md-demographic-content {
        background-color: #242a3d;
        position: relative;
        padding: 40px 0;
        @include media-600 {
            padding: 20px 0;
        }
    }
    .mg-container {
        position: relative;
        overflow: visible;
        .title-container {
            display: flex;
            align-content: center;
            justify-content: space-between;
            .refine-intro {
                font-size: 14px;
                color: #505050;
                font-family: var(--font-medium);
                line-height: 26px;
                display: flex;
                align-items: center;
                white-space: nowrap;
                .iconfont.icon-community {
                    margin-right: 10px;
                    color: #a8a8a8;
                }
            }
            .mg-title{
                flex-basis: fit-content;
                margin-left: 0;
            }
        }
        .mg-title {
            color: white;
            padding-bottom: 0px;
        }
        .mg-more {
            position: absolute;
            right: 0;
            bottom: -25px;
            font-family: var(--font-medium);
            font-size: 14px;
            letter-spacing: normal;
            text-transform: capitalize;
            .iconfont {
                transform: rotate(-90deg);
                display: inline-block;
            }
        }
        .demographic-content {
            background-color: #242a3d;
            justify-content: space-around;
            height: 140px;
            min-height: 120px;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            text-align: center;
            .divide {
                display: none;
            }
            .item {
                margin: 10px 0;
                display: flex;
                align-items: center;
                flex: none;
                .info {
                    .number {
                        font-family: var(--font-bold);
                        font-size: 30px;
                        letter-spacing: normal;
                        @include color-theme();
                        line-height: 36px;
                    }
                    .text {
                        font-family: var(--font-medium);
                        font-size: 14px;
                        letter-spacing: normal;
                        color: #bfc9e4;
                        line-height: 19px;
                        margin-top: 12px;
                    }
                }
            }
        }
    }
    @include media-600 {
        .mg-container {
            .mg-title {
                font-size: var(--mg-title-size-mobile);
                line-height: normal;
                letter-spacing: 0.8px;
            }
            .mg-more {
                font-size: 12px;
            }
            .demographic-content {
                height: auto;
                padding-bottom: 14px;
                margin: 14px 15px 0 15px;
                .item {
                    height: 80px;
                    width: calc(50% - 2px);
                    margin: 0px;
                    justify-content: center;
                    .info {
                        .item {
                            font-size: 18px;
                        }
                        .text {
                            margin-top: 0px;
                            font-size: 12px;
                        }
                    }
                }
            }
        }
    }
}
</style>
